import { Target, Layers, Zap } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 bg-[#0B1120]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 items-start">
          {/* Left: Heading */}
          <div className="lg:col-span-5 lg:sticky lg:top-32">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-amber-500" />
              <span className="font-tech text-amber-400 text-xs">THE ORGANIZATION</span>
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight">
              <span className="chrome-text">A Parent Company</span>
              <br />
              <span className="text-slate-200">With Specialized</span>
              <br />
              <span className="ember-text">Divisions.</span>
            </h2>
            <p className="mt-6 font-body text-slate-400 leading-relaxed">
              Master Ready Services, LLC isn't a single lead vendor — it's an organization
              of three specialized divisions, each engineered for a different segment of
              the contractor and home-service market.
            </p>
          </div>

          {/* Right: Mission text */}
          <div className="lg:col-span-7 space-y-6 font-body text-slate-300 text-[15px] md:text-base leading-relaxed">
            <p>
              Our mission is simple: <span className="text-white font-semibold">provide high-quality opportunities</span> that help our
              clients spend less time searching for customers and more time closing deals.
            </p>
            <p>
              Unlike most lead providers, we understand that every company operates differently.
              Some businesses require homeowner-only leads, others need decision-makers present.
              Some focus on storm restoration, insurance claims, solar consultations, or
              commercial opportunities. That's why we build <span className="text-amber-400">flexible
              campaigns</span> around your goals, service areas, budget, and qualification
              requirements.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5 pt-8">
              {[
                {
                  icon: Target,
                  title: "Precision Targeting",
                  copy: "Service-area, vertical, and qualifier-level targeting on every campaign.",
                },
                {
                  icon: Layers,
                  title: "Three Divisions",
                  copy: "Masters Ready, Big Ready Leads, and Rock Solid Storm Leads.",
                },
                {
                  icon: Zap,
                  title: "Built To Scale",
                  copy: "From a single rep operation to multi-state contractor fleets.",
                },
              ].map((b) => (
                <div
                  key={b.title}
                  className="forge-card p-5"
                  data-testid={`about-pillar-${b.title.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  <b.icon size={22} className="text-orange-400 mb-3" />
                  <div className="font-display text-lg tracking-tight mb-1">{b.title}</div>
                  <p className="text-slate-400 text-sm">{b.copy}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
